import { MerchantBalance } from "@components/balance";
import { FlexLoader } from "@components/loader";
import { Notifications } from "@components/notifications";
import { PayOutBalanceModal } from "@components/pay-out-balance-modal";
import { TransactionsInfo } from "@components/transactions-info";
import { useMerchantBalance } from "@features/merchantBalance";
import { useBoolState } from "@hooks/use-bool-state";
import { useNavigate } from "react-router-dom";
import styles from "./main.module.scss";
import { useWebSocket } from "@request/useWebsocket";
import { useEffect } from "react";
import { WebsocketUpdateType } from "@request/websocket";

export const MainPage = () => {
  const { state, getBalances } = useMerchantBalance();
  const [isModalOpen, showModal, hideModal] = useBoolState(false);

  const navigate = useNavigate();

  const { lastMessage } = useWebSocket();

  const websocketTypesToUpdateBalance = [
    WebsocketUpdateType.Balance,
    WebsocketUpdateType.Withdrawal,
    WebsocketUpdateType.Appeal,
    WebsocketUpdateType.Order,
    WebsocketUpdateType.PayOut,
  ];

  useEffect(() => {
    if (
      lastMessage &&
      websocketTypesToUpdateBalance.includes(lastMessage.type)
    ) {
      getBalances();
    }
  }, [lastMessage]);

  useEffect(() => {
    getBalances();
  }, [getBalances]);

  if (!state.balance) {
    return <FlexLoader />;
  }

  return (
    <>
      <div>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            <MerchantBalance
              className={styles.wallet}
              balance={state.balance.sum_usdt}
              onClickWithdraw={showModal}
              onClickHistory={() => navigate("settlements")}
            />
          </div>
          <TransactionsInfo
            profit={state.balance?.ern_balance?.amount ?? 0}
            formatType="usdt"
          />
        </div>
        <div className={styles.bottom}>
          <Notifications />
        </div>
      </div>
      <PayOutBalanceModal
        isModalOpen={isModalOpen}
        hideModal={hideModal}
        balance={Math.round(state.balance.sum_usdt * 100) / 100}
      />
    </>
  );
};
